import React, { useState } from 'react';
import { Button, Column } from '@tempmee/react';
import { OutlinePlusIcon } from '@tempmee/react-icons';
import { useGetCycles } from '../../../domain/Awards';
import useClampedPage from '../../../hooks/useClampedPage';
import { DsPagination } from '../../commonComponents/DsPagination';
import { ListPageHeader } from '../../commonComponents/ListPageHeader';
import { BestInDentalBreadcrumbs } from './components/BestInDentalBreadcrumbs';
import { CycleFormDialog } from './components/CycleFormDialog';
import { CycleListTable } from './components/CycleListTable';

export const BestInDental = () => {
  const [page, setPage] = useState(1);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const {
    cycles, pageSize, totalCount, isPending, isFetching, isError,
  } = useGetCycles(page);

  // A page can outlive its data — a refetch that returns fewer cycles leaves an
  // out-of-range page requesting an empty slice. Pull it back into range.
  useClampedPage(page, totalCount, pageSize, setPage);

  return (
    // AppShell's `main` carries no padding, so every page owns its gutters —
    // not added there because the legacy pages already pad themselves.
    <Column px={8} pt={4} pb={12} gap={5}>
      <BestInDentalBreadcrumbs isList />

      <ListPageHeader
        title="Best in Dental"
        isLoading={isFetching && cycles.length > 0}
        actions={(
          <Button
            onClick={() => setIsCreateOpen(true)}
            startIcon={<OutlinePlusIcon aria-hidden className="size-5" />}
          >
            Add cycle
          </Button>
        )}
      />

      <CycleListTable
        cycles={cycles}
        isPending={isPending}
        isError={isError}
        totalCount={totalCount}
        footer={(
          <DsPagination
            page={page}
            pageSize={pageSize}
            totalCount={totalCount}
            onPageChange={setPage}
          />
        )}
      />

      <CycleFormDialog open={isCreateOpen} onClose={() => setIsCreateOpen(false)} />
    </Column>
  );
};
